import {Injectable} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {LocalStorageService} from './local-storage.service';
import {Subject} from "rxjs";

@Injectable({
providedIn: 'root'
})
export class TranslateConfigService{

  private _langchange = new Subject<string>();
  _langchange$ = this._langchange.asObservable();

defaultLanguage = 'en';

constructor(private translateService: TranslateService, private localStorage: LocalStorageService) {
this.loadLanguage();
}

changeLanguage(language: string): void{
this.translateService.use(language);
this._langchange.next(language);
this.localStorage.save('language', language);
}

getCurrentLanguage(){
return this.translateService.currentLang;
}
loadLanguage(){
const languageCode = this.localStorage.get('language');
const setLanguageCode = languageCode ? languageCode : this.defaultLanguage;
this.changeLanguage(setLanguageCode);
}

}
